
import { purple, red } from '@mui/material/colors';
import './assets/scss/App.scss';

export const MuiTheme = {
	typography: {
		fontFamily: [
			'Figtree',
			'Poppins',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(',')
	},
	palette: {
		primary: {
			light: '#757ce8',
			main: '#3f50b5',
			dark: '#002884',
			contrastText: '#fff',
			gray: '#f9f9f9'
		},
		secondary: {
			main: `${process.env.REACT_APP_NODE_ENV === 'development' ? purple[300] : '#F26A22'}`
		},
		textBlack: {
			main: '#000000DE',
		},
		excelColors: {
			present: 'FFFFFFFF', // white
			halfAttendance: 'FFFFFFFF', // white
			absent: 'FFFFFFFF', // white
			holiday: 'FFCCFFCC', // Light Green
			leave: 'FFFF0000', // Red
			default: 'FFF4CCCC', // Light Red
			border: 'FF000000', // Black
		},
	},

};
